import React from 'react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Radio } from '@node-space/ui-components'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { WalletTypes } from 'types/types'
import { walletTypeAtom } from '../atoms/massPayoutAtoms'

export const MassPayoutTypeSelection = () => {
  const { t } = useTranslation()
  const [walletType, setWalletType] = useAtom(walletTypeAtom)
  const permissions = useMappedRoles()
  const canEdit = permissions?.massPayouts?.canEdit
  const onCurrencyTypeSelection = (type: string) => {
    setWalletType(type)
  }

  return (
    <Box>
      <Radio
        horizontal={false}
        border={false}
        name="currencyType"
        label={t('massPayouts.whatCurrenciesAreYouPayingOutIn')}
        onChange={onCurrencyTypeSelection}
        options={[
          {
            label: t('massPayouts.cryptocurrencies'),
            value: WalletTypes.CRYPTO,
            disabled: !canEdit,
          },
          {
            label: t('massPayouts.fiatMassPayoutOptionTypeLabel'),
            value: WalletTypes.FIAT,
            disabled: !canEdit,
          },
        ]}
        value={walletType}
      />
    </Box>
  )
}
